import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Layout } from 'antd';
import Login from './components/Login';
import Cadastro from './components/Cadastro';
import RecuperarSenha from './components/RecuperarSenha';
import RegistroResponsavel from './components/RegistroResponsavel';
import Sidebar from './components/Sidebar';
import PrivateRoute from './components/PrivateRoute';
import UsuariosList from './components/UsuariosList';
import UnidadesList from './components/UnidadesList';
import TipoUnidadesList from './components/TipoUnidadesList';
import TipoContratosList from './components/TipoContratosList';
import SeriesList from './components/SeriesList';
import ModalidadesList from './components/ModalidadesList';
import AlunosList from './components/AlunosList';
import EquipesList from './components/EquipesList';
import TurmasList from './components/TurmasList';
import MatriculasList from './components/MatriculasList';
import ContratosList from './components/ContratosList';
import AulasDadasList from './components/AulasDadasList';
import RelatorioMensal from './components/RelatorioMensal';
import FornecedoresList from './components/FornecedoresList';
import CategoriasDespesaList from './components/CategoriasDespesaList';
import DespesasList from './components/DespesasList';
import ReceitasList from './components/ReceitasList';
import FluxoCaixa from './components/FluxoCaixa';
import RelatoriosContabeis from './components/RelatoriosContabeis';
import RelatoriosOperacionais from './components/RelatoriosOperacionais';
import FolhaPagamento from './components/FolhaPagamento';
import ParcelasList from './components/ParcelasList';
import FaturasOperacional from './components/FaturasOperacional';
import FaturasGestao from './components/FaturasGestao';
import ResponsaveisList from './components/ResponsaveisList';
import ResponsavelDashboard from './components/ResponsavelDashboard';
import AcessoNegado from './components/AcessoNegado';
import PerfisList from './components/PerfisList';
import BasesPage from './components/BasesPage';
import DashboardExecutivo from './components/DashboardExecutivo';
import DashboardExecutivoV2 from './components/dashboardV2/DashboardExecutivoV2';
import DashboardRentabilidade from './components/DashboardRentabilidade';
import DashboardOperacional from './components/DashboardOperacional';
import DashboardComercial from './components/DashboardComercial';
import DashboardRH from './components/DashboardRH';
import DashboardFinanceiroDetalhado from './components/DashboardFinanceiroDetalhado';
import DashboardUnidades from './components/DashboardUnidades';
import DashboardParcelas from './components/DashboardParcelas';
import DataManagement from './components/DataManagement';
import Home from './components/Home';
import ConfiguracaoFiscal from './components/fiscal/ConfiguracaoFiscal';
import FaturasNfse from './components/fiscal/FaturasNfse';
import NotasFiscais from './components/fiscal/NotasFiscais';
import PortalProfessorHome from './components/portal_professor/PortalProfessorHome';
import ChamadaDetalhe from './components/portal_professor/ChamadaDetalhe';
import PortalProfessorLayout from './components/portal_professor/PortalProfessorLayout';
import PortalProfessorAulasDadas from './components/portal_professor/PortalProfessorAulasDadas';
import PortalProfessorTurmas from './components/portal_professor/PortalProfessorTurmas';
import PortalProfessorPagamentos from './components/portal_professor/PortalProfessorPagamentos';
import PortalProfessorAvaliacoes from './components/portal_professor/PortalProfessorAvaliacoes';
import PortalProfessorAvaliacaoTurma from './components/portal_professor/PortalProfessorAvaliacaoTurma';
import PortalProfessorAvaliacaoAluno from './components/portal_professor/PortalProfessorAvaliacaoAluno';
import PresencasAdmin from './components/presencas/PresencasAdmin';
import ChamadaAdminDetalhe from './components/presencas/ChamadaAdminDetalhe';
import AvaliacoesAdmin from './components/avaliacoes_admin/AvaliacoesAdmin';
import PeriodoAvaliacaoAdminDetalhe from './components/avaliacoes_admin/PeriodoAvaliacaoAdminDetalhe';
import ValidacoesAdminPainel from './components/avaliacoes_admin/ValidacoesAdminPainel';
import EventosAdmin from './components/eventos/EventosAdmin';
import InscricoesEventosAdmin from './components/eventos/InscricoesEventosAdmin';
import CobrancasEventosAdmin from './components/eventos/CobrancasEventosAdmin';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import './App.css';

const { Content } = Layout;

const AppContent = () => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();
  const isResponsavel = user?.role === 'RESPONSAVEL';
  const isProfessor = user?.role === 'PROFESSOR';
  const showSidebar = isAuthenticated && !isResponsavel && !isProfessor;

  const publicRoutes = ['/login', '/cadastro', '/recuperar-senha', '/registrar-responsavel'];
  const isPublicRoute = publicRoutes.includes(location.pathname);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <div>Carregando...</div>
      </div>
    );
  }

  const defaultRedirect = isResponsavel
    ? '/responsavel/dashboard'
    : isProfessor
      ? '/professor'
      : '/inicio';

  if (isPublicRoute) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/cadastro" element={<Cadastro />} />
        <Route path="/recuperar-senha" element={<RecuperarSenha />} />
        <Route path="/registrar-responsavel" element={<RegistroResponsavel />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  if (!isAuthenticated && !isPublicRoute) {
    return <Navigate to="/login" replace />;
  }

  if (isResponsavel && (location.pathname.startsWith('/dashboard') || location.pathname === '/inicio')) {
    return <Navigate to="/responsavel/dashboard" replace />;
  }

  // /inicio (home administrativa) nao restringe allowedRoles -- sem este
  // guard, um PROFESSOR que chegasse la (ex.: link antigo, digitacao
  // manual) veria a home do ADMIN em vez do Portal do Professor.
  if (isProfessor && location.pathname === '/inicio') {
    return <Navigate to="/professor" replace />;
  }

  return (
    <Layout style={{ minHeight: '100vh', marginLeft: showSidebar ? 280 : 0 }}>
      {showSidebar && <Sidebar />}
      <Layout>
        <Content style={{ padding: showSidebar ? '24px' : 0 }}>
          <Routes>
            <Route
              path="/inicio"
              element={
                <PrivateRoute>
                  <Home />
                </PrivateRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute allowedRoles={['ADMIN']}>
                  <DashboardExecutivo />
                </PrivateRoute>
              }
            />
            <Route
              path="/dashboard-operacional"
              element={
                <PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE']}>
                  <DashboardOperacional />
                </PrivateRoute>
              }
            />
            <Route
              path="/dashboard-comercial"
              element={
                <PrivateRoute allowedRoles={['ADMIN', 'RH']}>
                  <DashboardComercial />
                </PrivateRoute>
              }
            />
            <Route
              path="/dashboard-rh"
              element={
                <PrivateRoute allowedRoles={['ADMIN', 'RH']}>
                  <DashboardRH />
                </PrivateRoute>
              }
            />
            <Route
              path="/dashboard-financeiro"
              element={
                <PrivateRoute allowedRoles={['ADMIN', 'RH']}>
                  <DashboardFinanceiroDetalhado />
                </PrivateRoute>
              }
            />
            <Route
              path="/dashboard-parcelas"
              element={
                <PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE']}>
                  <DashboardParcelas />
                </PrivateRoute>
              }
            />
            <Route
              path="/dashboard-unidades"
              element={
                <PrivateRoute allowedRoles={['ADMIN']}>
                  <DashboardUnidades />
                </PrivateRoute>
              }
            />
            <Route
              path="/responsaveis/pendentes"
              element={
                <PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE']}>
                  <ResponsaveisList />
                </PrivateRoute>
              }
            />
            <Route
              path="/usuarios"
              element={
                <PrivateRoute allowedRoles={['ADMIN']}>
                  <UsuariosList />
                </PrivateRoute>
              }
            />
            <Route
              path="/unidades"
              element={
                <PrivateRoute allowedRoles={['ADMIN', 'RH']}>
                  <UnidadesList />
                </PrivateRoute>
              }
            />
            <Route
              path="/tipo-unidades"
              element={
                <PrivateRoute allowedRoles={['ADMIN', 'RH']}>
                  <TipoUnidadesList />
                </PrivateRoute>
              }
            />
            <Route
              path="/tipo-contratos"
              element={
                <PrivateRoute allowedRoles={['ADMIN', 'RH']}>
                  <TipoContratosList />
                </PrivateRoute>
              }
            />
            <Route
              path="/series"
              element={
                <PrivateRoute allowedRoles={['ADMIN', 'RH']}>
                  <SeriesList />
                </PrivateRoute>
              }
            />
            <Route
              path="/modalidades"
              element={
                <PrivateRoute allowedRoles={['ADMIN', 'RH']}>
                  <ModalidadesList />
                </PrivateRoute>
              }
            />
            <Route
              path="/alunos"
              element={
                <PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE']}>
                  <AlunosList />
                </PrivateRoute>
              }
            />
            <Route
              path="/equipe"
              element={
                <PrivateRoute allowedRoles={['ADMIN', 'RH']}>
                  <EquipesList />
                </PrivateRoute>
              }
            />
            <Route
              path="/turmas"
              element={
                <PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE', 'ALUNO', 'PROFESSOR']}>
                  <TurmasList />
                </PrivateRoute>
              }
            />
            <Route
              path="/matriculas"
              element={
                <PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE', 'ALUNO']}>
                  <MatriculasList />
                </PrivateRoute>
              }
            />
            <Route
              path="/contratos"
              element={
                <PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE']}>
                  <ContratosList />
                </PrivateRoute>
              }
            />
            <Route
              path="/aulas-dadas"
              element={
                <PrivateRoute allowedRoles={['ADMIN', 'RH', 'PROFESSOR']}>
                  <AulasDadasList />
                </PrivateRoute>
              }
            />
            <Route
              path="/relatorio-mensal"
              element={
                <PrivateRoute allowedRoles={['ADMIN', 'RH']}>
                  <RelatorioMensal />
                </PrivateRoute>
              }
            />
            {/* Gestão Administrativa de Presenças (Fase C): deliberadamente
                SEM allowedRoles -- diferente de todas as rotas acima, a
                autorização funcional não é decidida por role nenhuma aqui.
                PrivateRoute sem allowedRoles só exige autenticação; o
                controle de acesso real (podeVisualizar/podeEditar do
                recurso "presencas") acontece dentro do próprio componente,
                mesmo padrão já usado por RelatoriosContabeis.js. */}
            <Route
              path="/presencas"
              element={
                <PrivateRoute>
                  <PresencasAdmin />
                </PrivateRoute>
              }
            />
            <Route
              path="/presencas/nova"
              element={
                <PrivateRoute>
                  <ChamadaAdminDetalhe />
                </PrivateRoute>
              }
            />
            <Route
              path="/presencas/:encontroId"
              element={
                <PrivateRoute>
                  <ChamadaAdminDetalhe />
                </PrivateRoute>
              }
            />
            {/* Módulo de Eventos (Fase A: Evento + Sessão apenas).
                Deliberadamente SEM allowedRoles, mesmo padrão de
                Presenças acima -- a autorização real (podeVisualizar/
                podeCriar/podeEditar/podeExcluir do recurso "eventos",
                migration 093) acontece dentro do próprio componente via
                usePermissaoRecurso('eventos'). */}
            <Route
              path="/eventos"
              element={
                <PrivateRoute>
                  <EventosAdmin />
                </PrivateRoute>
              }
            />
            {/* Inscrições de Eventos (Fase B.3b): mesmo padrão de
                /eventos acima -- deliberadamente SEM allowedRoles, a
                autorização real (podeVisualizar/podeEditar do MESMO
                recurso "eventos") acontece dentro do próprio componente
                via usePermissaoRecurso('eventos'). Tela separada por ser
                um recorte transversal (todas as inscrições de todos os
                Eventos/Sessões), não uma sub-tela de EventosAdmin. */}
            <Route
              path="/eventos/inscricoes"
              element={
                <PrivateRoute>
                  <InscricoesEventosAdmin />
                </PrivateRoute>
              }
            />
            {/* Cobranças de Eventos (Fase B.5c.3b): mesmo padrão de
                /eventos/inscricoes acima -- deliberadamente SEM
                allowedRoles, a autorização real (podeVisualizar do MESMO
                recurso "eventos") acontece dentro do próprio componente
                via usePermissaoRecurso('eventos'). Consome
                GET /api/eventos/cobrancas (Fase B.5c.3a, read-only) e a
                ação "Gerar cobrança" já existente de B.5c.1 -- nenhum
                endpoint novo de emissão/backend nesta fase. */}
            <Route
              path="/eventos/cobrancas"
              element={
                <PrivateRoute>
                  <CobrancasEventosAdmin />
                </PrivateRoute>
              }
            />
            {/* Gestão Administrativa de Avaliações de Alunos (Fase 7):
                recurso "avaliacoes_gestao" é exclusivo de ADMIN por
                migration 079 (nenhum outro perfil pode receber grant) --
                diferente de Presenças, aqui allowedRoles=['ADMIN'] no
                próprio Route é redundante, mas seguro, com o gate real
                de usePermissaoRecurso dentro dos componentes. */}
            <Route
              path="/avaliacoes"
              element={
                <PrivateRoute allowedRoles={['ADMIN']}>
                  <AvaliacoesAdmin />
                </PrivateRoute>
              }
            />
            <Route
              path="/avaliacoes/periodos/:periodoId"
              element={
                <PrivateRoute allowedRoles={['ADMIN']}>
                  <PeriodoAvaliacaoAdminDetalhe />
                </PrivateRoute>
              }
            />
            {/* Validação administrativa (Fase 12): recurso RBAC PRÓPRIO
                "avaliacoes_validacao", DELIBERADAMENTE distinto de
                "avaliacoes_gestao" -- pode ser concedido a outros perfis
                (ex.: RH) pela tela Perfis, sem abrir a gestão inteira.
                Por isso, diferente das rotas de "avaliacoes_gestao" acima,
                aqui NÃO usamos allowedRoles=['ADMIN'] -- PrivateRoute só
                exige autenticação, e o próprio componente decide
                visibilidade via usePermissaoRecurso('avaliacoes_validacao')
                (mesmo padrão já usado em /presencas). */}
            <Route
              path="/avaliacoes/validacao"
              element={
                <PrivateRoute>
                  <ValidacoesAdminPainel />
                </PrivateRoute>
              }
            />
            <Route
              path="/fornecedores"
              element={
                <PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE']}>
                  <FornecedoresList />
                </PrivateRoute>
              }
            />
            <Route
              path="/categorias-despesa"
              element={
                <PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE']}>
                  <CategoriasDespesaList />
                </PrivateRoute>
              }
            />
            <Route
              path="/despesas"
              element={
                <PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE']}>
                  <DespesasList />
                </PrivateRoute>
              }
            />
            <Route
              path="/receitas"
              element={
                <PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE']}>
                  <ReceitasList />
                </PrivateRoute>
              }
            />
            <Route
              path="/parcelas"
              element={
                <PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE']}>
                  <ParcelasList />
                </PrivateRoute>
              }
            />
            <Route
              path="/faturas"
              element={
                <PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE']}>
                  <Navigate to="/faturas/operacional" replace />
                </PrivateRoute>
              }
            />
            <Route
              path="/faturas/operacional"
              element={
                <PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE']}>
                  <FaturasOperacional />
                </PrivateRoute>
              }
            />
            <Route
              path="/faturas/gestao"
              element={
                <PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE']}>
                  <FaturasGestao />
                </PrivateRoute>
              }
            />
            <Route
              path="/fluxo-caixa"
              element={
                <PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE']}>
                  <FluxoCaixa />
                </PrivateRoute>
              }
            />
            <Route
              path="/relatorios-contabeis"
              element={
                <PrivateRoute>
                  <RelatoriosContabeis />
                </PrivateRoute>
              }
            />
            <Route
              path="/relatorios-operacionais"
              element={
                <PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE']}>
                  <RelatoriosOperacionais />
                </PrivateRoute>
              }
            />
            <Route
              path="/folha-pagamento"
              element={
                <PrivateRoute>
                  <FolhaPagamento />
                </PrivateRoute>
              }
            />
            <Route
              path="/responsavel/dashboard"
              element={
                <PrivateRoute allowedRoles={['RESPONSAVEL']}>
                  <ResponsavelDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/professor"
              element={
                <PrivateRoute allowedRoles={['PROFESSOR']}>
                  <PortalProfessorLayout>
                    <PortalProfessorHome />
                  </PortalProfessorLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/professor/encontros/:encontroId/chamada"
              element={
                <PrivateRoute allowedRoles={['PROFESSOR']}>
                  <PortalProfessorLayout>
                    <ChamadaDetalhe />
                  </PortalProfessorLayout>
                </PrivateRoute>
              }
            />
            {/* Fase 14A: estrutura de navegação apenas -- estas três rotas
                mostram um placeholder neutro até suas respectivas fases
                (14B/14C/14D) implementarem a tela funcional real. Nenhum
                dado, chamada de API ou regra de negócio aqui. */}
            <Route
              path="/professor/aulas-dadas"
              element={
                <PrivateRoute allowedRoles={['PROFESSOR']}>
                  <PortalProfessorLayout>
                    <PortalProfessorAulasDadas />
                  </PortalProfessorLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/professor/turmas"
              element={
                <PrivateRoute allowedRoles={['PROFESSOR']}>
                  <PortalProfessorLayout>
                    <PortalProfessorTurmas />
                  </PortalProfessorLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/professor/pagamentos"
              element={
                <PrivateRoute allowedRoles={['PROFESSOR']}>
                  <PortalProfessorLayout>
                    <PortalProfessorPagamentos />
                  </PortalProfessorLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/professor/avaliacoes"
              element={
                <PrivateRoute allowedRoles={['PROFESSOR']}>
                  <PortalProfessorLayout>
                    <PortalProfessorAvaliacoes />
                  </PortalProfessorLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/professor/avaliacoes/turmas/:avaliacaoTurmaId"
              element={
                <PrivateRoute allowedRoles={['PROFESSOR']}>
                  <PortalProfessorLayout>
                    <PortalProfessorAvaliacaoTurma />
                  </PortalProfessorLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/professor/avaliacoes/alunos/:avaliacaoAlunoId"
              element={
                <PrivateRoute allowedRoles={['PROFESSOR']}>
                  <PortalProfessorLayout>
                    <PortalProfessorAvaliacaoAluno />
                  </PortalProfessorLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/acesso-negado"
              element={
                <PrivateRoute>
                  <AcessoNegado />
                </PrivateRoute>
              }
            />
            <Route
              path="/perfis"
              element={
                <PrivateRoute allowedRoles={['ADMIN']}>
                  <PerfisList />
                </PrivateRoute>
              }
            />
            <Route
              path="/gestao-dados"
              element={
                <PrivateRoute allowedRoles={['ADMIN']}>
                  <DataManagement />
                </PrivateRoute>
              }
            />
            <Route
              path="/sistema/bases"
              element={
                <PrivateRoute allowedRoles={['ADMIN']}>
                  <BasesPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/dashboard-executivo-v2"
              element={
                <PrivateRoute allowedRoles={['ADMIN']}>
                  <DashboardExecutivoV2 />
                </PrivateRoute>
              }
            />
            <Route
              path="/dashboard-rentabilidade"
              element={
                <PrivateRoute allowedRoles={['ADMIN']}>
                  <DashboardRentabilidade />
                </PrivateRoute>
              }
            />
            <Route
              path="/fiscal/configuracao"
              element={
                <PrivateRoute allowedRoles={['ADMIN']}>
                  <ConfiguracaoFiscal />
                </PrivateRoute>
              }
            />
            <Route
              path="/fiscal/emissao"
              element={
                <PrivateRoute allowedRoles={['ADMIN']}>
                  <FaturasNfse />
                </PrivateRoute>
              }
            />
            <Route
              path="/fiscal/notas"
              element={
                <PrivateRoute allowedRoles={['ADMIN']}>
                  <NotasFiscais />
                </PrivateRoute>
              }
            />
            <Route path="/" element={<Navigate to={defaultRedirect} replace />} />
            <Route path="*" element={<Navigate to={defaultRedirect} replace />} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

const App = () => (
  <AuthProvider>
    <AppContent />
  </AuthProvider>
);

export default App;
